export default __webpack_public_path__ + "static/media/report-active.2d7e9b21.svg";